/* unplugin-vue-components disabled */
import {Rest} from 'utils'
import {stringToFile} from 'utils/utils'
import {API2_AUDIT} from 'consts/api2'

export default {
  data() {
    return {
      rest: new Rest(),
      loading: false,
      data: {}
    }
  },
  computed: {
    audit_logs_cert() {
      return this.data.cert
    },
    audit_logs_valid_to() {
      return new Date(this.data.valid_to).toLocaleString()
    },
    audit_logs_privkey() {
      return this.data.privkey
    },
    audit_logs_pubkey() {
      return this.data.pubkey
    },
    audit_logs_pass() {
      return this.data.pass
    },
    role_arn() {
      return this.data.role_arn
    },
    ta_arn() {
      return this.data.trust_anchor_arn
    },
    profile_arn() {
      return this.data.profile_arn
    },
    bucket_name() {
      return this.data.bucket_name
    },
    have_certs() {
      return this.audit_logs_cert && this.audit_logs_privkey && this.audit_logs_pass && this.audit_logs_pubkey && this.bucket_name
    },
  },
  async mounted() {
    this.loading = true
    this.data = await this.rest.get(`${API2_AUDIT}/info`)
    this.loading = false
  },
  methods: {
    async onCreate() {
      this.loading = true
      const credentials = await this.rest.post(`${API2_AUDIT}/recreate`)
      this.data = {...this.data, ...credentials}
      this.loading = false
      $utils.toasts.success('Audit logs credentials recreated successfully', 5000)
    },
    stringToFile(data, fname) {
      return stringToFile(data, fname)
    }
  }
}
